module.exports = {
  plus: [{
    text: 'Á mjög illa við mig',
    score: 1,
    color: 1
  }, {
    text: 'Á illa við mig',
    score: 2,
    color: 2
  }, {
    text: 'Á hvorki vel né illa við mig',
    score: 3,
    color: 3
  }, {
    text: 'Á vel við mig',
    score: 4,
    color: 4
  }, {
    text: 'Á mjög vel við mig',
    score: 5,
    color: 5
  }],
  minus: [{
    text: 'Á mjög illa við mig',
    score: 5,
    color: 1
  }, {
    text: 'Á illa við mig',
    score: 4,
    color: 2
  }, {
    text: 'Á hvorki vel né illa við mig',
    score: 3,
    color: 3
  }, {
    text: 'Á vel við mig',
    score: 2,
    color: 4
  }, {
    text: 'Á mjög vel við mig',
    score: 1,
    color: 5
  }]
};